import { FormControl } from '@angular/forms';

export interface CredentialsForm {
  username: FormControl<string>;
  password: FormControl<string>;
  grant_type: FormControl<string>;
}

export interface AuthSession {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token: string;
}

// Generated by https://quicktype.io

export interface UserClaims {
  claims: Claim[];
  expirate: number;
  pe: number;
}

export interface Claim {
  type: string;
  value: string;
}

export enum Claims {
  SubActiva = 'SubActiva',
  Finaliza = 'Finaliza',
  LoggedOn = 'LoggedOn',
  CodOrganizacion = 'CodOrganizacion',
  CodOrganizacionAUTH = 'CodOrganizacionAUTH',
  CodUsuario = 'CodUsuario',
  ValorInicial = 'ValorInicial',
  verify = 'verify',
  Email = 'Email',
  NombreOrganizacion = 'NombreOrganizacion',
}

export interface SignUpReponse {
  CodUsuario:          number;
  CodYcUsuario:        number;
  CodOrganizacion:     number;
  CodOrganizacionAUTH: number;
  UrlRedirect:         string;
  UrlRedirect2:        string;
}
